export default {
  // 页面标题
  title: "推送记录",
  
  // 搜索表单
  searchForm: {
    pushTime: "推送时间",
    pushTimePlaceholder: "请选择时间范围",
    memberAccount: "推送会员",
    memberAccountPlaceholder: "请输入",
    pushType: "推送类型",
    pushTypePlaceholder: "获取该消息的推送主类",
    memberType: "会员类型",
    memberTypePlaceholder: "请选择",
    status: "状态",
    statusPlaceholder: "请选择",
    search: "查询",
    reset: "重置"
  },
  
  // 表格列标题
  table: {
    memberAccount: "推送会员",
    pushType: "推送类型",
    memberType: "会员类型",
    pushTitle: "推送标题",
    pushContent: "推送内容",
    pushTime: "推送时间",
    status: "状态"
  },
  
  // 状态
  status: {
    success: "成功",
    failed: "失败"
  },
  
  // 分页
  pagination: {
    total: "共 {total} 条记录",
    pageInfo: "第 {currentPage}/{totalPages} 页",
    itemsPerPage: "条/页",
    jumpTo: "跳至",
    page: "页"
  },
  
  // 消息
  messages: {
    fetchDataFailed: "获取数据失败",
    noData: "暂无数据",
    timeRangeExceeded: "查询时间范围不可超过 1 个月，请重新选择。"
  }
};
